import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function About() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <section className="pt-28 pb-16 px-4 md:px-8 lg:px-12 bg-background-50">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center border border-foreground-300 rounded-full px-5 py-1.5 text-xs font-medium tracking-wider uppercase text-foreground-600 mb-6">
                Our Story
              </div>
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-medium text-foreground-950 mb-4">
                About Castillo Painting
              </h1>
              <p className="text-foreground-600 max-w-lg mx-auto">
                A family-owned painting company dedicated to quality and customer satisfaction.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-12">
              <div>
                <img
                  src="https://storage.readdy-site.link/project_files/a52140d7-8dc9-4301-8963-1eb215a641bf/cc6b88f4-b8b2-4fcd-aaa6-46dc0ce6da1e_compressed_portrait.webp"
                  alt="Castillo Painting team at work"
                  className="w-full h-[500px] md:h-[600px] object-contain bg-background-100 rounded-2xl"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h2 className="font-heading text-2xl font-medium text-foreground-950 mb-4">
                  Welcome to Castillo Paint Inc.
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Hello, my name is Jose Castillo, CEO and Founder of Castillo Paint Inc.
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  After more than 15 years of experience in the painting industry, I made the decision to become a licensed contractor and build a company founded on quality workmanship, honesty, and exceptional customer service.
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  At Castillo Paint Inc., we take pride in transforming homes and businesses with professional painting services that enhance both beauty and value. Whether it&rsquo;s a residential or commercial project, our commitment is to deliver outstanding results using quality materials, skilled craftsmanship, and attention to every detail.
                </p>
                <p className="text-foreground-600 leading-relaxed mb-4">
                  Our goal is simple: to exceed our customers&rsquo; expectations on every project while building lasting relationships through trust, reliability, and professionalism.
                </p>
                <p className="text-foreground-600 leading-relaxed">
                  Thank you for considering Castillo Paint Inc. We look forward to bringing your vision to life.
                </p>
              </div>
            </div>

            <div className="bg-background-100 rounded-2xl p-8 md:p-10 mb-12">
              <h2 className="font-heading text-2xl font-medium text-foreground-950 mb-6 text-center">
                Why Choose Us
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {[
                  { icon: "ri-shield-check-line", title: "Licensed & Insured", desc: "Full license #1150059 with bonding and insurance for your peace of mind." },
                  { icon: "ri-award-line", title: "Quality Materials", desc: "We use premium paints and coatings that last longer and look better." },
                  { icon: "ri-focus-3-line", title: "Attention to Detail", desc: "Every project receives personal attention from start to finish, ensuring precise prep work, clean lines, and a flawless result." },
                  { icon: "ri-customer-service-line", title: "Customer First", desc: "Your satisfaction is our priority. We communicate clearly and deliver on time." },
                ].map((item) => (
                  <div key={item.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-primary-600`}></i>
                    </div>
                    <div>
                      <h3 className="font-medium text-foreground-950 text-sm mb-1">{item.title}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="text-center">
              <h2 className="font-heading text-2xl font-medium text-foreground-950 mb-4">
                Ready to Get Started?
              </h2>
              <p className="text-foreground-600 mb-6 max-w-md mx-auto">
                Contact us today for a free quote and consultation. We look forward to bringing color to your space.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a href="/contact" className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  Get a Free Quote
                  <i className="ri-arrow-right-line"></i>
                </a>
                <a href="tel:9514792556" className="inline-flex items-center justify-center gap-2 bg-background-100 text-foreground-700 border border-background-300 px-6 py-3 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line"></i>
                  Call (951) 479-2556
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}